export default "__VITE_ASSET__$hMVloa2__"